import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { Component } from 'react';

import styles from '../styles/original-email-modal.module.scss';

type PropsT = {
  originalEmail: any;
  originalEmailCloseModal: () => void;
  originalEmailHtmlGetByType: (payload: any) => Promise<any>;
};

type StateT = {
  showRewrittenHtmlRawEmail: boolean;
  showOriginalHtmlEmail: boolean;
  showOriginalHtmlRawEmail: boolean;
  showTextEmail: boolean;
  showAllData: boolean;
  htmlIframeSrc: string;
  emailText: string;
  orginalHtmlIframeSrc: string;
};

const PROP_MAP = {
  rewritten_html: 'htmlIframeSrc',
  html: 'orginalHtmlIframeSrc',
  text: 'emailText',
};

class OriginalEmailModal extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);
    this.state = {
      showRewrittenHtmlRawEmail: false,
      showOriginalHtmlEmail: false,
      showOriginalHtmlRawEmail: false,
      showTextEmail: false,
      showAllData: false,
      htmlIframeSrc: '',
      emailText: '',
      orginalHtmlIframeSrc: '',
    };
  }

  getOriginalEmailByType(type: string) {
    const { currentOriginalEmail } = this.props.originalEmail;
    const original = currentOriginalEmail[type];
    const prop = PROP_MAP[type] || 'htmlIframeSrc';

    (original
      ? Promise.resolve(original)
      : this.props.originalEmailHtmlGetByType({
          type,
          url: `${currentOriginalEmail.requestURL}`,
        })
    )
      .then((response: string) => {
        this.setState({ [prop]: response } as any);
      })
      .catch((exception: Error) => {
        console.error('Exception', exception);
      });
  }

  componentDidUpdate(prevProps: PropsT) {
    if (
      this.props.originalEmail.ui.showModal === true &&
      prevProps.originalEmail.ui.showModal === false
    ) {
      this.getHtmlEmail();
      this.getTextEmail();
      this.getOrginalHtmlEmail();
    } else if (
      this.props.originalEmail.ui.showModal === false &&
      prevProps.originalEmail.ui.showModal === true
    ) {
      // Reset state when closing the modal.
      this.setState({
        showRewrittenHtmlRawEmail: false,
        showOriginalHtmlEmail: false,
        showOriginalHtmlRawEmail: false,
        showTextEmail: false,
        showAllData: false,
        htmlIframeSrc: '',
        emailText: '',
        orginalHtmlIframeSrc: '',
      });
    }
  }

  getHtmlEmail = () => {
    this.getOriginalEmailByType('rewritten_html');
  };

  getOrginalHtmlEmail = () => {
    this.getOriginalEmailByType('html');
  };

  getTextEmail = () => {
    this.getOriginalEmailByType('text');
  };

  render() {
    return (
      <Modal
        className={styles.originalEmailModal}
        isOpen={this.props.originalEmail.ui.showModal}
        onClose={this.props.originalEmailCloseModal}
        allowClickOutside
        allowEscClose
      >
        <ModalHead
          title="View original email"
          onClose={this.props.originalEmailCloseModal}
        />
        <ModalBody>
          <div>
            <h3 className="header">Rewritten HTML email</h3>
            <pre className={styles.pre}>
              <Button
                className={styles.toggleHtmlRaw}
                onClick={() => {
                  this.setState({
                    showRewrittenHtmlRawEmail:
                      !this.state.showRewrittenHtmlRawEmail,
                  });
                }}
              >
                {this.state.showRewrittenHtmlRawEmail === true
                  ? 'Hide source'
                  : 'Show source'}
              </Button>
              {this.state.showRewrittenHtmlRawEmail === false && (
                <iframe
                  srcDoc={`${this.state.htmlIframeSrc}`}
                  style={{ border: '0', width: '100%', height: '100vh' }}
                  sandbox=""
                />
              )}
              {this.state.showRewrittenHtmlRawEmail === true && (
                <iframe
                  src={`data:text/plain;charset=utf-8,${this.state.htmlIframeSrc}`}
                  style={{ border: '0', width: '100%', height: '100vh' }}
                  sandbox=""
                />
              )}
            </pre>
          </div>

          <div>
            <h3 className="header">
              Original HTML email{' '}
              <Button
                onClick={() => {
                  this.setState({
                    showOriginalHtmlEmail: !this.state.showOriginalHtmlEmail,
                  });
                }}
              >
                {this.state.showOriginalHtmlEmail === true
                  ? 'Hide original HTML email'
                  : 'View original HTML email'}
              </Button>
            </h3>
            {this.state.showOriginalHtmlEmail === true &&
              this.state.orginalHtmlIframeSrc !== '' && (
                <pre>
                  <Button
                    className="toggle-html-raw"
                    onClick={() => {
                      this.setState({
                        showOriginalHtmlRawEmail:
                          !this.state.showOriginalHtmlRawEmail,
                      });
                    }}
                  >
                    {this.state.showOriginalHtmlRawEmail === true
                      ? 'Hide source'
                      : 'Show source'}
                  </Button>
                  {this.state.showOriginalHtmlRawEmail === false && (
                    <iframe
                      srcDoc={`${this.state.orginalHtmlIframeSrc}`}
                      style={{
                        border: '0',
                        width: '100%',
                        height: '100vh',
                      }}
                      sandbox=""
                    />
                  )}
                  {this.state.showOriginalHtmlRawEmail === true && (
                    <iframe
                      src={`data:text/plain;charset=utf-8,${this.state.orginalHtmlIframeSrc}`}
                      style={{
                        border: '0',
                        width: '100%',
                        height: '100vh',
                      }}
                      sandbox=""
                    />
                  )}
                </pre>
              )}
          </div>

          <div>
            <h3 className="header">
              Plain text email{' '}
              <Button
                onClick={() => {
                  this.setState({
                    showTextEmail: !this.state.showTextEmail,
                  });
                }}
              >
                {this.state.showTextEmail === true
                  ? 'Hide text email'
                  : 'View text email'}
              </Button>
            </h3>
            {this.state.showTextEmail === true &&
              this.state.emailText !== '' && (
                <pre style={{ whiteSpace: 'pre-wrap' }}>
                  {this.state.emailText}
                </pre>
              )}
          </div>

          <div>
            <h3 className="header">
              Email data{' '}
              <Button
                onClick={() => {
                  this.setState({ showAllData: !this.state.showAllData });
                }}
              >
                {this.state.showAllData === true
                  ? 'Hide email data'
                  : 'View email data'}
              </Button>
            </h3>
            {this.props.originalEmail.currentOriginalEmail &&
              this.state.showAllData === true && (
                <pre>
                  {JSON.stringify(
                    this.props.originalEmail.currentOriginalEmail.msg ||
                      this.props.originalEmail.currentOriginalEmail,
                    null,
                    2,
                  )}
                </pre>
              )}
          </div>
        </ModalBody>
        <ModalFoot>
          <div className="buttons">
            <Button type="button" onClick={this.props.originalEmailCloseModal}>
              Close
            </Button>
          </div>
        </ModalFoot>
      </Modal>
    );
  }
}

export default OriginalEmailModal;
